import type { FaireProductEntity } from "../../entity_types/product";

export const p_p87naybuxm: FaireProductEntity = {
  token: "p_p87naybuxm",
  type: "product",
  name: "Tri-Pine Customizable Crew Neck  Tee",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/96b84b74fc7272989c33684378589c29d19b4824a78bc81996093af6a172a59c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/131db55cf92607673d661c4bd2e9f4702fc23714954fb774e80f25462b50e13e.jpeg",
    "https://cdn.faire.com/fastly/e52869539476052bc67e8b9e89739d781f4ad24cbf252c82700aa6be9a802321.jpeg",
    "https://cdn.faire.com/fastly/a7a567343a60ce1d1feeb583b122bf7cb5f8d0fe6affabf2743ca694bf379cbd.jpeg",
    "https://cdn.faire.com/fastly/00dae8eafb9892626b897f6072b1524e51c858b9ff66e87ae642d76c98cdece8.jpeg",
    "https://cdn.faire.com/fastly/ecb81e930b6d6f0044229d538c9676e1e578252072ca39e1a74bedfbbcde5532.jpeg"
  ],
  priceDollars: 13,
  description: "New Graphic for 2023. Our customizable Tri-Pine Graphic is ready for tees. Yeah!\nWe will add your location or business name to the graphic.\n\nWe are offering our new graphic in fun colors as well as some staples. Sizing will be X-Small to 3X-Large.\n\nOur tees are manufactured by Bella Canvas and all graphics are print by MT Brand Apparel at their Stevensville, Montana location.",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:49.661Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
